import { render, staticRenderFns } from "./knowledgeManage.vue?vue&type=template&id=7239b0a8&scoped=true"
import script from "./knowledgeManage.vue?vue&type=script&lang=js"
export * from "./knowledgeManage.vue?vue&type=script&lang=js"
import style0 from "./knowledgeManage.vue?vue&type=style&index=0&id=7239b0a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7239b0a8",
  null
  
)

export default component.exports